import React from "react";

const agents = [
  { icon: "📈", title: "Ask The Chart", desc: "AI explains any live chart in plain English." },
  { icon: "🧠", title: "Smart Narrator", desc: "Narrated walkthroughs of key price movements." },
  { icon: "📊", title: "Market Sentiment", desc: "Daily mood of the market in 5 seconds." },
  { icon: "🎯", title: "Trade Hints", desc: "Get hints on what setups to focus on next." },
  { icon: "🔍", title: "Pattern Scanner", desc: "Find chart patterns automatically." },
  { icon: "📅", title: "Event Explainer", desc: "Why did the market move? AI explains." },
  { icon: "👀", title: "Watchlist Agent", desc: "Track assets and receive AI summaries." },
  { icon: "🕒", title: "Weekly Outlook", desc: "Plan your trading week with AI forecasts." },
  { icon: "📌", title: "Risk Review Agent", desc: "Quick checks before any big move." },
  { icon: "📚", title: "Concept Clarity", desc: "Break down concepts like RSI or MACD." },
  { icon: "📈", title: "Trend Detector", desc: "Identify trend direction instantly." },
  { icon: "📉", title: "Pullback Agent", desc: "Spot healthy retracements vs reversals." },
  { icon: "🚀", title: "Momentum Agent", desc: "Find momentum setups based on volume/speed." },
  { icon: "🔄", title: "Reversal Watch", desc: "Spot double tops, bottoms, and divergences." },
  { icon: "🪙", title: "Crypto Clarity", desc: "What’s moving in crypto and why." },
  { icon: "💱", title: "Forex Fixer", desc: "Explain sudden moves in major forex pairs." },
  { icon: "📋", title: "Journal Summary Agent", desc: "Summarize your trading journal weekly." },
  { icon: "📈", title: "Breakout Watcher", desc: "Get AI’s view on breakout strength." },
  { icon: "🔗", title: "Correlation Agent", desc: "Spot correlations across assets." },
  { icon: "💬", title: "Chat With Chart", desc: "Just ask what’s going on — any time." }
];

const AgentsSection = () => (
  <section id="courses" className="courses-section">
    <div className="container">
      <h2>20 AI Agents to Simplify Your Daily Trading Routine</h2>
      <div className="steps-grid">
        {agents.map((c, i) => (
          <div
            className="step"
            key={i}
            onClick={() => window.location.href = "/agent-access"}
            style={{ cursor: "pointer" }}
          >
            <span className="icon-placeholder">{c.icon}</span>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AgentsSection;